import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useBookingsList() {
    //User toast
    const toast = useToast()

    const refBookingListTable = ref(null)

    const tableColumns = [
        {key: 'id', label:'ID', stickyColumn: true, sortable: true},
        {key: 'customer.name'},
        {key: 'coach.coach_name', label: 'COACH'},
        {key: 'lesson_time', label: 'START TIME',sortable: true},
        {key: 'end_time', label: 'END TIME'},
        {key: 'number_of_lesson'},
        {key: 'booking_stage', label:'STAGE'},
        {key: 'actions'},
    ]

    //Filter
    const bookingstageFilter = ref(null)
    const coachFilter = ref(null)
    const customerFilter = ref(null)

    const perPage = ref(10)
    const totalBookings = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refBookingListTable.value ? refBookingListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBookings.value,
        }
    })

    const refetchData = () => {
        refBookingListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, bookingstageFilter, coachFilter, customerFilter ], () => {
        refetchData()
    })

    const fetchBookings = (ctx, callback) => {
        store.dispatch('booking/fetchBookings',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            is_active: -1, // As defined -1 means get all booking not matter it is active or not
            language_id: 1,
            booking_stage_id: bookingstageFilter.value,
            coach_id: coachFilter.value,
            customer_id: customerFilter.value,
        })
        .then(response =>{
            const {bookings, total} = response.data
            callback(bookings)
            totalBookings.value = total
        
        })
        .catch((error) => {
            console.log(error)
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching booking list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchBookings,
        tableColumns,
        perPage,
        currentPage,
        totalBookings,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refBookingListTable,
        ability,
        refetchData,
        bookingstageFilter,
        coachFilter,
        customerFilter,
    }

}